"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timePickerButton = {
    marginLeft: 5,
    backgroundColor: 'transparent',
    borderColor: 'transparent'
};
const operatorDropdown = {
    width: 0,
    height: 0
};
exports.default = {
    timePickerButton,
    operatorDropdown
};
